import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const C = {
  navy: "#0f1f45",
  navyMid: "#1e3a6e",
  navyLight: "#2d5aa0",
  white: "#ffffff",
  text: "#111827",
  textSub: "#374151",
  textMuted: "#6b7280",
  border: "#d1d5db",
  rowAlt: "#ffffff",
};

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 9,
    fontFamily: "Helvetica",
    backgroundColor: C.white,
    color: C.text,
  },

  headerBanner: {
    width: "100%",
    padding: 0,
    margin: 0,
  },
  headerBannerImage: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },

  body: {
    paddingHorizontal: 24,
    paddingTop: 12,
  },

  noTrxRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 10,
  },
  noTrxBox: {
    backgroundColor: C.navyMid,
    borderRadius: 5,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  noTrxLabel: {
    fontSize: 7,
    color: "rgba(255,255,255,0.7)",
  },
  noTrxValue: {
    fontSize: 9,
    color: C.white,
    fontFamily: "Helvetica-Bold",
  },

  sectionTitle: {
    fontSize: 15,
    fontFamily: "Helvetica-Bold",
    color: C.text,
    marginBottom: 2,
  },
  sectionDivider: {
    borderBottomColor: C.navyMid,
    borderBottomWidth: 2,
    marginBottom: 8,
  },

  infoRow: {
    flexDirection: "row",
    marginBottom: 2,
  },
  infoLabel: {
    width: 68,
    fontSize: 8,
    color: C.textSub,
  },
  infoColon: {
    width: 10,
    fontSize: 8,
    color: C.textSub,
  },
  infoValue: {
    flex: 1,
    fontSize: 8,
    color: C.text,
  },

  tableWrap: {
    marginTop: 12,
    marginBottom: 8,
    borderColor: C.border,
    borderWidth: 1,
    borderRadius: 4,
    overflow: "hidden",
  },
  thRow1: {
    flexDirection: "row",
    backgroundColor: C.navyMid,
    paddingVertical: 5,
    paddingHorizontal: 6,
  },
  thRow2: {
    flexDirection: "row",
    backgroundColor: C.navy,
    paddingVertical: 4,
    paddingHorizontal: 6,
    borderTopWidth: 1,
  },
  thText: {
    fontSize: 7,
    fontFamily: "Helvetica-Bold",
    color: C.white,
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 6,
    borderTopColor: C.border,
    borderTopWidth: 1,
    backgroundColor: C.white,
  },
  tableRowAlt: {
    backgroundColor: C.rowAlt,
  },
  tdBold: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: C.text,
  },
  tdText: {
    fontSize: 8,
    color: C.text,
  },
  tdMuted: {
    fontSize: 8,
    color: C.textSub,
  },
  totalRow: {
    flexDirection: "row",
    backgroundColor: C.navyMid,
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  totalText: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: C.white,
  },

  colDesc: {
    width: "30%",
  },
  colQty: {
    width: "10%",
    alignItems: "center",
  },
  colNom: {
    width: "20%",
    alignItems: "flex-end",
  },
  colSpecial: {
    width: "40%",
    alignItems: "center",
  },
  colDisc: {
    width: "20%",
    alignItems: "flex-end",
  },
  colRebate: {
    width: "20%",
    alignItems: "flex-end",
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  summaryLabel: {
    fontSize: 8,
    color: C.textSub,
  },
  summaryValue: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: C.text,
  },

  couponWrap: {
    marginTop: 4,
    marginBottom: 6,
  },
  couponText: {
    fontSize: 8,
    color: C.text,
    lineHeight: 1.5,
  },

  termsTitle: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    color: C.text,
    marginTop: 6,
    marginBottom: 3,
  },
  termsText: {
    fontSize: 7,
    color: C.textSub,
    lineHeight: 1.55,
    marginBottom: 8,
  },

  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 8,
    paddingBottom: 24,
  },
  footerLeft: {
    width: "60%",
  },
  footerRight: {
    width: "40%",
    alignItems: "center",
  },
  footerText: {
    fontSize: 8,
    color: C.textSub,
    lineHeight: 1.5,
  },
  footerBrand: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: C.navyMid,
    marginTop: 4,
  },
  signatureLine: {
    borderTopColor: C.border,
    borderTopWidth: 1,
    width: "80%",
    marginTop: 36,
    marginBottom: 4,
  },
  signatureName: {
    fontSize: 8,
    fontFamily: "Helvetica-Bold",
    color: C.text,
  },
});

const TERMS = [
  "Setiap pembelian 1 (satu) paket transaksi akan mendapatkan 1 (satu) kupon hadiah yang berkesempatan memenangkan hadiah spesial pada malam acara.",
  "Program ini berlaku untuk seluruh produk polycarbonate dari PT Impack Pratama Industri Tbk.",
  "Periode penyelesaian paket berlaku hingga 31 Agustus 2026.",
  "Extra diskon diberikan langsung pada saat transaksi.",
  "Benefit uang elektronik akan diberikan setelah program berakhir, dengan ketentuan peserta telah menyelesaikan 100% paket yang dipilih serta melalui proses verifikasi oleh tim audit.",
  "Program paket harga spektakuler dapat digabungkan dengan program reguler yang sedang berlangsung.",
  "Skema perhitungan harga adalah sebagai berikut: Pricelist – Diskon Normal – Promo Reguler – Extra Diskon Paket.",
  "Panitia berhak membatalkan paket apabila ditemukan ketidaksesuaian terhadap ketentuan yang berlaku di lapangan.",
];

const formatDate = () => {
  const today = new Date();

  const months = [
    "JANUARI",
    "FEBRUARI",
    "MARET",
    "APRIL",
    "MEI",
    "JUNI",
    "JULI",
    "AGUSTUS",
    "SEPTEMBER",
    "OKTOBER",
    "NOVEMBER",
    "DESEMBER",
  ];

  return `${today.getDate()} ${
    months[today.getMonth()]
  } ${today.getFullYear()}`;
};

const fmt = (num) => Number(num || 0).toLocaleString("id-ID");

const formatCouponRanges = (coupons = []) => {
  if (!coupons?.length) return "";

  const nums = [
    ...new Set(
      coupons
        .map((item) => parseInt(item.coupon, 10))
        .filter((num) => !Number.isNaN(num)),
    ),
  ].sort((a, b) => a - b);

  if (!nums.length) return "";

  const ranges = [];

  let start = nums[0];
  let end = nums[0];

  for (let i = 1; i < nums.length; i++) {
    if (nums[i] === end + 1) {
      end = nums[i];
      continue;
    }

    ranges.push(start === end ? `${start}` : `${start} - ${end}`);

    start = nums[i];
    end = nums[i];
  }

  ranges.push(start === end ? `${start}` : `${start} - ${end}`);

  return ranges.join(", ");
};

const resolveCouponText = ({ couponText, couponRange, coupon }) => {
  const totalCoupon = Number(couponRange?.totalCoupon || 0);

  if (couponRange?.couponStart && couponRange?.couponEnd && totalCoupon > 0) {
    return `${couponRange.couponStart} - ${couponRange.couponEnd} (${totalCoupon} kupon)`;
  }

  if (couponText) {
    const alreadyHasTotal = String(couponText).toLowerCase().includes("kupon");

    if (alreadyHasTotal) {
      return couponText;
    }

    if (coupon?.length) {
      return `${couponText} (${coupon.length} kupon)`;
    }

    return couponText;
  }

  const rangeText = formatCouponRanges(coupon);

  if (rangeText && coupon?.length) {
    return `${rangeText} (${coupon.length} kupon)`;
  }

  return rangeText;
};

export default function ContractPDF({
  contract = [],
  summary = [],
  coupon = [],
  couponRange = null,
  couponText = "",
  info,
  no,
}) {
  const totalQty = contract.reduce((sum, item) => {
    return sum + Number(item.quantity || 0);
  }, 0);

  const finalCouponText = resolveCouponText({
    couponText,
    couponRange,
    coupon,
  });
  console.log(contract);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerBanner}>
          <Image src="Header SolarTuff.jpg" style={styles.headerBannerImage} />
        </View>

        <View style={styles.body}>
          <View style={styles.noTrxRow}>
            <View style={styles.noTrxBox}>
              <Text style={styles.noTrxLabel}>No Transaksi</Text>
              <Text style={styles.noTrxValue}>{no}</Text>
            </View>
          </View>

          <Text style={styles.sectionTitle}>Form Kontrak Pembelian</Text>
          <View style={styles.sectionDivider} />

          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Nama</Text>
            <Text style={styles.infoColon}>:</Text>
            <Text style={styles.infoValue}>{info?.name || "-"}</Text>
          </View>

          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>Nama Toko</Text>
            <Text style={styles.infoColon}>:</Text>
            <Text style={styles.infoValue}>{info?.storeName || "-"}</Text>
          </View>

          <View style={styles.infoRow}>
            <Text style={styles.infoLabel}>No. HP</Text>
            <Text style={styles.infoColon}>:</Text>
            <Text style={styles.infoValue}>{info?.phoneNo || "-"}</Text>
          </View>

          <View style={styles.tableWrap}>
            <View style={styles.thRow1}>
              <View style={styles.colDesc}>
                <Text style={styles.thText}>PAKET DESCRIPTION</Text>
              </View>

              <View style={styles.colQty}>
                <Text style={styles.thText}>QUANTITY</Text>
              </View>

              <View style={styles.colNom}>
                <Text
                  style={[styles.thText, { textAlign: "right", width: "100%" }]}
                >
                  NOMINAL TRANSAKSI
                </Text>
              </View>

              <View style={styles.colSpecial}>
                <Text
                  style={[
                    styles.thText,
                    { textAlign: "center", width: "100%" },
                  ]}
                >
                  PENAWARAN SPESIAL
                </Text>
              </View>
            </View>

            <View style={styles.thRow2}>
              <View style={styles.colDesc} />
              <View style={styles.colQty} />
              <View style={styles.colNom} />

              <View style={styles.colDisc}>
                <Text
                  style={[
                    styles.thText,
                    { textAlign: "center", width: "100%" },
                  ]}
                >
                  POT. HARGA
                </Text>
              </View>

              <View style={styles.colRebate}>
                <Text
                  style={[styles.thText, { textAlign: "right", width: "100%" }]}
                >
                  UANG ELEKTRONIK
                </Text>
              </View>
            </View>

            {contract.map((item, index) =>
              item.products.map((product, productIndex) => (
                <View
                  key={`${index}-${productIndex}`}
                  style={[
                    styles.tableRow,
                    index % 2 === 1 ? styles.tableRowAlt : {},
                  ]}
                >
                  <View style={styles.colDesc}>
                    {productIndex === 0 ? (
                      <Text>
                        <Text style={styles.tdBold}>{item.packageName} : </Text>
                        <Text style={styles.tdMuted}>
                          {product.productName}
                        </Text>
                      </Text>
                    ) : (
                      <Text style={[styles.tdMuted, { paddingLeft: 8 }]}>
                        {product.productName}
                      </Text>
                    )}
                  </View>

                  <View style={styles.colQty}>
                    <Text style={styles.tdText}>
                      {productIndex === 0 ? fmt(item.quantity) : ""}
                    </Text>
                  </View>

                  <View style={styles.colNom}>
                    <Text
                      style={[
                        styles.tdText,
                        { textAlign: "right", width: "100%" },
                      ]}
                    >
                      {productIndex === 0
                        ? `Rp ${fmt(item.quantity * 10000000 || 0)}`
                        : ""}
                    </Text>
                  </View>

                  <View style={styles.colDisc}>
                    <Text
                      style={[
                        styles.tdText,
                        { textAlign: "center", width: "100%" },
                      ]}
                    >
                      {productIndex === 0 ? `${fmt(item.packageId)}%` : ""}
                    </Text>
                  </View>

                  <View style={styles.colRebate}>
                    <Text
                      style={[
                        styles.tdText,
                        { textAlign: "right", width: "100%" },
                      ]}
                    >
                      {productIndex === 0 ? `Rp ${fmt(item.uangElek)}` : ""}
                    </Text>
                  </View>
                </View>
              )),
            )}

            <View style={styles.totalRow}>
              <View style={styles.colDesc}>
                <Text style={styles.totalText}>TOTAL PAKET</Text>
              </View>

              <View style={styles.colQty}>
                <Text style={styles.totalText}>{fmt(totalQty)}</Text>
              </View>

              <View style={styles.colNom}>
                <Text
                  style={[
                    styles.totalText,
                    { textAlign: "right", width: "100%" },
                  ]}
                >
                  {`Rp ${fmt(totalQty * 10000000 || 0)}`}
                </Text>
              </View>

              <View style={styles.colDisc} />

              <View style={styles.colRebate} />
            </View>
          </View>

          {summary.map((item, index) => (
            <View key={index} style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>{item.productName}</Text>
              <Text style={styles.summaryValue}>{item.quantity} PAKET</Text>
            </View>
          ))}

          {finalCouponText && (
            <View style={styles.couponWrap}>
              <Text style={styles.couponText}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Kupon: </Text>
                {finalCouponText}
              </Text>
            </View>
          )}

          <Text style={styles.termsTitle}>Syarat dan Ketentuan</Text>
          <Text style={styles.termsText}>
            {TERMS.map((term, index) => `${index + 1}. ${term}`).join("\n")}
          </Text>

          <View style={styles.footer}>
            <View style={styles.footerLeft}>
              <Text style={styles.footerText}>
                Terima kasih! Berikut rincian data pesanan Anda. Tim kami akan
                segera menghubungi Anda.
              </Text>

              <Text style={styles.footerBrand}>
                SolarTuff{"\n\n\n\n"}
                Hormat kami{"\n"}
                PT. Impack Pratama Industri.Tbk
              </Text>
            </View>

            <View style={styles.footerRight}>
              <Text
                style={[styles.footerText, { fontFamily: "Helvetica-Bold" }]}
              >
                JAKARTA, {formatDate()}
              </Text>

              <View style={styles.signatureLine} />

              <Text style={styles.signatureName}>{info?.name || "-"}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
